export const convertMbToBytes = (mb: number) => mb * 1024 ** 2;
